"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var dateFormat_1 = require("../../constants/dateFormat");
var FormatText_1 = __importDefault(require("../FormatText"));
var ColumnType;
(function (ColumnType) {
    ColumnType["Date"] = "Date";
    ColumnType["Check"] = "Check";
    ColumnType["Switch"] = "Switch";
})(ColumnType = exports.ColumnType || (exports.ColumnType = {}));
var transformColumnOptions = function (columnOptions, renderActions) {
    var resultOptions = columnOptions.map(function (colOpt) {
        if (colOpt.title && typeof colOpt.title === 'string') {
            colOpt.title = react_1.default.createElement(FormatText_1.default, { id: colOpt.title });
        }
        if (!colOpt.render) {
            if (colOpt.type) {
                switch (colOpt.type) {
                    case ColumnType.Date:
                        colOpt.render = function (text) {
                            return text && moment_1.default(text).format(dateFormat_1.dateFormat);
                        };
                        break;
                    case ColumnType.Check:
                        colOpt.render = function (text) {
                            return react_1.default.createElement(antd_1.Checkbox, { checked: text });
                        };
                        break;
                    case ColumnType.Switch:
                        colOpt.render = function (text) {
                            return react_1.default.createElement(antd_1.Switch, { checked: text });
                        };
                        break;
                    default:
                        break;
                }
            }
            else if (colOpt.options) {
                var optionsMap_1 = colOpt.options.reduce(function (acc, opt) {
                    if (opt.value)
                        acc[opt.value] = opt.text || '';
                    return acc;
                }, {});
                colOpt.render = function (text) {
                    return react_1.default.createElement("span", null, optionsMap_1[text]);
                };
            }
        }
        return colOpt;
    });
    if (renderActions) {
        resultOptions.push({
            title: react_1.default.createElement(FormatText_1.default, { id: "ui.commons.actions" }),
            key: 'editAction',
            width: 120,
            render: renderActions,
        });
    }
    return resultOptions;
};
var Table = function (_a) {
    var _b = _a.rowKey, rowKey = _b === void 0 ? 'id' : _b, columns = _a.columns, dataSource = _a.dataSource, renderActions = _a.renderActions, tableProps = __rest(_a, ["rowKey", "columns", "dataSource", "renderActions"]);
    var columnOptions = react_1.useMemo(function () { return transformColumnOptions(columns || [], renderActions); }, [columns, renderActions]);
    var xSize = react_1.useMemo(function () {
        if (dataSource && dataSource.length > 0 && columnOptions && columnOptions.length > 3) {
            return columnOptions.length * 100;
        }
        return 400;
    }, [dataSource, columnOptions]);
    return (react_1.default.createElement("div", { className: "ant-app-datatable" },
        react_1.default.createElement(antd_1.Table, __assign({ rowKey: rowKey, scroll: { x: xSize } }, tableProps, { dataSource: dataSource, columns: columnOptions }))));
};
exports.default = Table;
